import { ContractChangesQuery, ContractChangesQueryVariables } from '../../../types'
import { ApolloError, useQuery } from '@apollo/client'
import ContractQueries from '../../contract/ContractQueries'

export default (employeeId: number): { data: ContractChangesQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const { data, error, loading } = useQuery<ContractChangesQuery, ContractChangesQueryVariables>(ContractQueries.ContractChanges, {
    variables: {
      employeeId: employeeId,
    },
  })

  return { data, error, loading }
}
